import { Pipe, PipeTransform } from '@angular/core';
import { NoticeService } from '@df/ui/api/notice/notice.service';

@Pipe({
    name: 'notice',
    standalone: true
})
export class NoticePipe extends NoticeService implements PipeTransform {}
